export default __webpack_public_path__ + "static/media/Picture13.8e6b7ceb.png";